import { startCase } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

import { SnPlayerService } from 'libs/player/common/src/lib/services/player.service';

@Component({
  selector: 'fs-ai-box',
  templateUrl: './ai-box.component.html',
  styleUrls: ['./ai-box.component.scss'],
})
export class AiBoxComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() public resolution;
  @Input() public xValue: number;
  @Input() public yValue: number;
  @Input() public widthValue: number;
  @Input() public heightValue: number;
  @Input() public meta: any;

  public isAvailable: boolean;
  public style: any = {};
  public styleMeta: any = {};
  public x: number;
  public y: number;
  public width: number;
  public height: number;
  public contentLoaded: boolean = false;
  public fullScreen: boolean;
  public metaData: any[] = [];

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _playerService: SnPlayerService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this._playerService.fullscreen$.pipe(takeUntil(this._destroy$)).subscribe((value) => {
      this.fullScreen = value === 'open' ? true : false;
    });

    this.contentLoaded = false;
    this.x = (this.xValue / this.resolution.width) * 100;
    this.y = (this.yValue / this.resolution.height) * 100;
    this.width = (this.widthValue / this.resolution.width) * 100;
    this.height = (this.heightValue / this.resolution.height) * 100;
    this.metaData = this.meta;
    this.isAvailable =
      this.meta?.metadata && Object.keys(this.formatFields(this.meta?.metadata)).length > 0;
  }

  public ngAfterViewInit(): void {
    this.onResize(this.x, this.y, this.width, this.height);
    this.contentLoaded = true;
    let metaW = {};
    let metaH = {};
    if (this.x + this.width > 50) {
      metaW = {
        right: `${100 - this.x}%`,
      };
    } else {
      metaW = {
        left: `${this.x + this.width}%`,
      };
    }
    if (this.y + this.height > 50) {
      metaH = {
        bottom: `${100 - (this.y + this.height)}%`,
      };
    } else {
      metaH = {
        top: `${this.y}%`,
      };
    }

    this.styleMeta = {
      ...this.styleMeta,
      ...metaW,
      ...metaH,
    };
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public formatFields(data: Object): Object {
    if (data === undefined || data === null) {
      return;
    }
    if (data['type'] === 'detection') {
      if (data['vehicleSignature']) {
        delete data['vehicleSignature'];
      }
      if (data['trackerId']) {
        delete data['trackerId'];
      }
    }
    if (data['type'] === 'event') {
      return { ruleName: data['ruleName'] };
    }
    return data;
  }

  public formatConfidence(confidence: number): number {
    return Math.round(confidence * 100) / 100;
  }

  public toStartCase(field: string): string {
    return startCase(field);
  }

  public isArray(item: any): boolean {
    return Array.isArray(item);
  }

  public isObject(item: any): boolean {
    return Object.prototype.toString.call(item).indexOf('Object') > -1;
  }

  public doResize(): void {
    this.x = (this.xValue / this.resolution.width) * 100;
    this.y = (this.yValue / this.resolution.height) * 100;
    this.width = (this.widthValue / this.resolution.width) * 100;
    this.height = (this.heightValue / this.resolution.height) * 100;
    this.onResize(this.x, this.y, this.width, this.height);
  }

  public onResize(
    xPercent: number,
    yPercent: number,
    widthPercent: number,
    heightPercent: number,
  ): void {
    this.style = {
      ...this.style,
      left: `${xPercent}%`,
      top: `${yPercent}%`,
      width: `${widthPercent}%`,
      height: `${heightPercent}%`,
    };
    this._changeDetectorRef.detectChanges();
  }

  public trackBy(index: number, item: any): any {
    return item.label;
  }
}
